import styled from 'styled-components'

export const ContainerResultados = styled.div`
  width: 100%;
  background: #ffff;
  display: ${props => props.active ? 'flex' : 'none'};
  margin-top: 12px;
  padding: 6px 5px 6px 5px;
  border-radius: 0 4px 4px 4px;
  /* box-shadow: -3px 8px 14px -2px #e5e5e5; */
  z-index: 20;
  transition: all cubic-bezier(0.075, 0.82, 0.165, 1);

  &::before {
    content: "";
    display: inline-block;
    vertical-align: middle;
    margin-right: 0;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid white;
    position: absolute;
    bottom: 2px;
  }

  ul {
    width: 100%;

    li {
      padding: 3px;
      color: #363843;

      &:hover {
        background-color: #f2f2f2;
      }
    }

  }

  @media (max-width: 1200px) {
    &::before {
      bottom: -13px;
    }
  }

`
